/* eslint-disable max-len */
import EDC from '../../../shared/globals';

EDC.Animations.AnswerResult = function (scene) {
  this.scene = scene;
  this.x = this.scene.game.config.width / 2;
  this.y = 250;
  this.text = null;
  this.bgCorrect = null;
  this.bgWrong = null;
  this.target = null;
  this.isRunning = false;
  this.callback = null;
  this.container = null;
};

EDC.Animations.AnswerResult.prototype.create = function () {
  this.container = this.scene.add.container(this.x, this.y);
  this.bgCorrect = this.scene.add.graphics();
  this.bgCorrect.lineStyle(10, 0x00ff00, 1);
  this.bgCorrect.fillStyle(0x000000, 0.4);
  this.bgCorrect.fillRoundedRect(-300, -150, 600, 300, 50);
  this.bgCorrect.strokeRoundedRect(-300, -150, 600, 300, 50);
  this.container.add(this.bgCorrect);

  this.bgWrong = this.scene.add.graphics(this.x, this.y);
  this.bgWrong.lineStyle(10, 0xff0000, 1);
  this.bgWrong.fillStyle(0x000000, 0.4);
  this.bgWrong.fillRoundedRect(-300, -150, 600, 300, 50);
  this.bgWrong.strokeRoundedRect(-300, -150, 600, 300, 50);
  this.container.add(this.bgWrong);

  this.text = this.scene.add.text(0, 0, '', {
    fontFamily: 'Arial', fontStyle: 'bold', fontSize: '90px', fill: 'white', align: 'center',
  });
  this.text.setOrigin(0.5);
  this.text.setAlpha(0);
  this.container.add(this.text);

  this.text.setScale(0);
  this.bgCorrect.setScale(0, 0);
  this.bgWrong.setScale(0, 0);
  return this;
};

EDC.Animations.AnswerResult.prototype.show = function (isCorrect, correctNumber, wrongNumber, callback) {
  this.callback = callback;
  const wrong = `WRONG!\n${wrongNumber} < ${correctNumber}`;
  const correct = `CORRECT!\n${correctNumber} > ${wrongNumber}`;
  this.text.setText(isCorrect ? correct : wrong);
  this.text.setScale(0);

  if (isCorrect) {
    this.target = this.bgCorrect;
  } else {
    this.target = this.bgWrong;
  }
  this.text.setPosition(this.target.x, this.target.y);
  this.text.setAlpha(1);

  this.isRunning = true;
  this.scaleUp();
};

EDC.Animations.AnswerResult.prototype.scaleUp = function () {
  this.scene.tweens.add({
    targets: [this.target, this.text],
    scaleX: 1,
    scaleY: 1,
    duration: 500,
    ease: 'Linear',
    onComplete: function () {
      this.scene.time.addEvent({ delay: 2500, callback: this.scaleDown, callbackScope: this });
    }.bind(this),
  });
};

EDC.Animations.AnswerResult.prototype.scaleDown = function () {
  this.scene.tweens.add({
    targets: [this.target, this.text],
    scaleX: 0,
    scaleY: 0,
    duration: 500,
    ease: 'Linear',
    onComplete: function () {
      if (this.callback) {
        this.isRunning = false;
        this.callback.call();
      }
    }.bind(this),
  });
};

export default EDC.Animations.AnswerResult;
